import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=45a4bf1f&scoped=true&"
import script from "./talk.vue?vue&type=script&lang=js&"
export * from "./talk.vue?vue&type=script&lang=js&"
import style0 from "./talk.vue?vue&type=style&index=0&id=45a4bf1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4bf1f",
  null
  
)

export default component.exports